var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "beforeclass-wrapper" }, [
    _c("p", { staticClass: "title" }, [_vm._v("课前必做")]),
    _vm._v(" "),
    _c("p", { staticClass: "info" }, [
      _vm._v("完成所有的班级事务之后，才能正常上课")
    ]),
    _vm._v(" "),
    _vm.data.class_notice
      ? _c("div", { staticClass: "detail" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.data.class_notice == 1
            ? _c(
                "span",
                {
                  staticClass: "unaccomplished",
                  on: {
                    click: function($event) {
                      return _vm.tofinish(1)
                    }
                  }
                },
                [_vm._v("去查看")]
              )
            : _vm.data.class_notice == 2
            ? _c("span", { staticClass: "finished" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/follow.png") }
                }),
                _vm._v("已查看")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.class_assistance
      ? _c("div", { staticClass: "detail" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm.data.class_assistance == 1
            ? _c(
                "span",
                {
                  staticClass: "unaccomplished",
                  on: {
                    click: function($event) {
                      _vm.isshow = true
                    }
                  }
                },
                [_vm._v("去关注")]
              )
            : _vm.data.class_assistance == 2
            ? _c("span", { staticClass: "finished" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/follow.png") }
                }),
                _vm._v("已关注")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.class_handout
      ? _c("div", { staticClass: "detail" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm.data.class_handout == 1
            ? _c(
                "span",
                {
                  staticClass: "unaccomplished",
                  on: {
                    click: function($event) {
                      return _vm.tofinish(
                        2,
                        _vm.data.code,
                        _vm.data.mail_system_sn
                      )
                    }
                  }
                },
                [_vm._v("去申请")]
              )
            : _vm.data.class_handout == 2
            ? _c("span", { staticClass: "finished" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/follow.png") }
                }),
                _vm._v("已申请")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.class_agreement
      ? _c("div", { staticClass: "detail" }, [
          _vm._m(3),
          _vm._v(" "),
          _vm.data.class_agreement == 1
            ? _c(
                "span",
                {
                  staticClass: "unaccomplished",
                  on: {
                    click: function($event) {
                      return _vm.tofinish(3)
                    }
                  }
                },
                [_vm._v("去签订")]
              )
            : _vm.data.class_agreement == 2
            ? _c("span", { staticClass: "finished" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/follow.png") }
                }),
                _vm._v("已签订")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.class_archives
      ? _c("div", { staticClass: "detail" }, [
          _vm._m(4),
          _vm._v(" "),
          _vm.data.class_archives == 1
            ? _c(
                "span",
                { staticClass: "unaccomplished", on: { click: _vm.tofinish } },
                [_vm._v("去完善")]
              )
            : _vm.data.class_archives == 2
            ? _c("span", { staticClass: "finished" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/follow.png") }
                }),
                _vm._v("已完善")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.class_attend_class
      ? _c("div", { staticClass: "detail" }, [
          _vm._m(5),
          _vm._v(" "),
          _vm.data.class_attend_class == 1
            ? _c(
                "span",
                { staticClass: "unaccomplished", on: { click: _vm.tofinish } },
                [_vm._v("去开课")]
              )
            : _vm.data.class_attend_class == 2
            ? _c("span", { staticClass: "finished" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/follow.png") }
                }),
                _vm._v("已开课")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isshow
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "box" }, [
            _c("p", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.data.assistance_name))
            ]),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("img", {
              staticClass: "qrcode",
              attrs: { src: _vm.data.assistance_url }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "tip" }, [
              _vm._v("长按保存二维码，打开微信扫一扫")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "copy_title" }, [
              _vm._v("复制公众号去关注"),
              _c("img", {
                staticClass: "copy",
                attrs: { src: require("../../../static/images/copy.png") },
                on: { click: _vm.copy_text }
              }),
              _c("input", {
                staticClass: "learn_text",
                attrs: { type: "text" },
                domProps: { value: _vm.data.assistance_name }
              })
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "close",
              attrs: { src: require("../../../static/images/shut.png") },
              on: {
                click: function($event) {
                  _vm.isshow = false
                }
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.flag
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "content" }, [
              _c("img", {
                attrs: { src: require("../../../static/images/shut_off.png") },
                on: { click: _vm.close }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "class_notice_title" }, [
                _vm._v("课前须知")
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "class_notice_text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.data.class_notice_text.replace(/\n/g, "<br/>")
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "read_close",
                class: [_vm.count > 0 ? "disabled" : ""],
                on: { click: _vm.record }
              },
              [
                _vm._v("我知道了"),
                _vm.count
                  ? _c("span", [
                      _vm._v("（"),
                      _c("span", { staticClass: "countdown" }, [
                        _vm._v(_vm._s(_vm.count) + "S")
                      ]),
                      _vm._v("）")
                    ])
                  : _vm._e()
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("../../../static/images/beforeclass.png") }
      }),
      _vm._v("课前须知")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("../../../static/images/assistant.png") }
      }),
      _vm._v("关注微信学习助手")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", { attrs: { src: require("../../../static/images/book.png") } }),
      _vm._v("教辅配送")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("../../../static/images/agreements.png") }
      }),
      _vm._v("协议与凭证")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("../../../static/images/archives.png") }
      }),
      _vm._v("学员档案")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", { attrs: { src: require("../../../static/images/self.png") } }),
      _vm._v("自助开课")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subtitle" }, [
      _vm._v("关注公众号，绑定开课手机号"),
      _c("br"),
      _vm._v("即可获取直播提醒和更多学习服务")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7545ac8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7545ac8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beforeClass/index.vue
// module id = null
// module chunks = 